import { LegalShell, LegalSection } from "./LegalShell";

export default function Impressum() {
  return (
    <LegalShell title="Impressum">
      <LegalSection heading="Angaben gemäß § 5 TMG">
        <p className="font-semibold text-[#0A0A0A]">SA Webdesign</p>
        <p>Inhaber: Stephan Appenzeller</p>
        <p>Bahnstraße 19<br />40878 Ratingen<br />Deutschland</p>
        <p>
          Telefon: <a href="tel:+4916094869112" className="text-[#2563EB] hover:underline">0160 94869112</a>
          <br />
          E-Mail: <a href="mailto:stephan@sa-webdesign.net" className="text-[#2563EB] hover:underline">stephan@sa-webdesign.net</a>
          <br />
          Website: <a href="https://www.sa-webdesign.net" className="text-[#2563EB] hover:underline">https://www.sa-webdesign.net</a>
        </p>
      </LegalSection>
      <LegalSection heading="Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG">
        <p>(wird nach Erhalt ergänzt)</p>
      </LegalSection>
      <LegalSection heading="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
        <p>Stephan Appenzeller<br />Bahnstraße 19<br />40878 Ratingen</p>
      </LegalSection>
      <LegalSection heading="EU-Streitschlichtung">
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
          <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#2563EB] hover:underline">
            https://ec.europa.eu/consumers/odr/
          </a>
        </p>
        <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
      </LegalSection>
      <LegalSection heading="Verbraucherstreitbeilegung">
        <p>
          Wir sind weder verpflichtet noch bereit, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </LegalSection>
    </LegalShell>
  );
}
